import {
  CheckIcon,
  LockClosedIcon,
  XMarkIcon,
} from '@heroicons/react/16/solid';
import { useEffect } from 'react';
import { Button, Modal } from 'react-daisyui';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { RouterPaths } from '../../../../components/Router/Router.constants';
import { useSubscriptionAnalytics } from 'src/hooks/analytics/subscription/useSubscriptionAnalytics.hook';
import { SettingsTabs } from '../../../../pages/Settings/Settings.enum';
import { useModalsContext } from '../../../ModalsProvider/Modals.context';
import { useSubscriptionContext } from '../../Subscription.context';
export default function SubscribeUsersModal() {
  const { showSubscribeAddUsersModal, setShowSubscribeAddUsersModal } =
    useModalsContext();
  const navigate = useNavigate();
  const { t } = useTranslation('subscription/modals');
  const { setUpInfo, getPlans } = useSubscriptionContext();
  const { trackPurchaseCta } = useSubscriptionAnalytics();

  // BUG-868: nothing auto-fetches plans on active workspaces — without this
  // the title interpolated a blank price. Mounted on open; RET-1190 guards
  // concurrent calls.
  useEffect(() => {
    if (!setUpInfo) void getPlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      open={showSubscribeAddUsersModal}
      onClose={() => setShowSubscribeAddUsersModal(false)}
      className="SubscribeUsersModal"
    >
      <Modal.Body className="SubscribeUsersModal__content">
        <div className="SubscribeUsersModal__left_side">
          {/* This button is only visible on sm screens using tailwind */}
          <Button
            shape="circle"
            size="sm"
            color="ghost"
            variant="outline"
            className="SubscribeUsersModal__left_side__button"
            onClick={() => setShowSubscribeAddUsersModal(false)}
          >
            <XMarkIcon className="SubscribeUsersModal__right_side__icon" />
          </Button>
          <div className="SubscribeUsersModal__left_side__warning">
            <LockClosedIcon className="w-6 h-6" />
            <p className="text-sm font-medium">
              {t('addUsers.subscriptionWarning')}
            </p>
          </div>
          <p className="SubscribeUsersModal__left_side__title">
            {setUpInfo ? (
              <Trans
                i18nKey="subscription/modals:addUsers.title"
                components={{ span: <span className="text-accent" /> }}
                values={{
                  setUpPrice: setUpInfo.trialCost,
                  currency: setUpInfo.currency,
                }}
              />
            ) : (
              <Trans
                i18nKey="subscription/modals:addUsers.titleNoPrice"
                components={{ span: <span className="text-accent" /> }}
              />
            )}
          </p>
          <div className=" overflow-auto h-[300px] sm:h-full">
            <div className="SubscribeUsersModal__left_side__features">
              <p>{t('addUsers.subtitle')}</p>
              <div className="SubscribeUsersModal__left_side__feature">
                <CheckIcon className="w-6 h-6" />
                <p>
                  <Trans
                    i18nKey="subscription/modals:addUsers.features.feature1"
                    components={{ span: <span className="font-bold" /> }}
                  />
                </p>
              </div>
              <div className="SubscribeUsersModal__left_side__feature">
                <CheckIcon className="w-6 h-6" />
                <p>
                  <Trans
                    i18nKey="subscription/modals:addUsers.features.feature2"
                    components={{ span: <span className="font-bold" /> }}
                  />
                </p>
              </div>
              <div className="SubscribeUsersModal__left_side__feature">
                <CheckIcon className="w-8 h-8" />
                <p>
                  <Trans
                    i18nKey="subscription/modals:addUsers.features.feature3"
                    components={{ span: <span className="font-bold" /> }}
                  />
                </p>
              </div>
            </div>
            {setUpInfo && (
              <p className="text-xs mt-4">
                <Trans
                  i18nKey="subscription/modals:addUsers.disclaimer"
                  components={{
                    b: <b />,
                    br: <br />,
                  }}
                  values={{
                    fullPrice: setUpInfo.monthlyPrice.toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD',
                    }),
                    currency: setUpInfo.currency,
                  }}
                />
              </p>
            )}
          </div>
          <Button
            color="primary"
            className="w-full"
            onClick={() => {
              navigate(
                `${RouterPaths.settings}?section=${SettingsTabs.SUBSCRIPTION}&cta_type=AddUsers`,
              );
              setShowSubscribeAddUsersModal(false);
              trackPurchaseCta('AddUsers', 'AddUsers');
            }}
          >
            Activa tu plan hoy
          </Button>
        </div>
        <div className="SubscribeUsersModal__right_side">
          <Button
            shape="circle"
            size="sm"
            color="ghost"
            className="SubscribeUsersModal__right_side__closeButton"
            onClick={() => setShowSubscribeAddUsersModal(false)}
          >
            <XMarkIcon className="SubscribeUsersModal__right_side__icon" />
          </Button>
          <img
            src="/images/subscriptions/AddUsers.png"
            alt="leadsales-logo"
            className="SubscribeUsersModal__right_side__image"
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}
